/**
 * Report a click through event. A click through event is when a user
 * clicks on a result within an autocomplete Dropdown.
 *
 * @param documentId String The document ID associated with result that was
 * clicked
 * @param tag Array[String] Optional Tags which can be used to categorize
 * this click event
 */
export default function trackAutocompleteClickThrough(documentId) {
  var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (this.debug) {
    var _console; // eslint-disable-next-line no-console


    (_console = console).log.apply(_console, ["Search UI: Action", "trackAutocompleteClickThrough"].concat(Array.prototype.slice.call(arguments)));
  }

  var _this$state = this.state,
      autocompletedResultsRequestId = _this$state.autocompletedResultsRequestId,
      searchTerm = _this$state.searchTerm;
  this.events.autocompleteResultClick({
    query: searchTerm,
    documentId: documentId,
    requestId: autocompletedResultsRequestId,
    tags: tags
  });
}